import { useGetAccountQuery } from "api/api-accounts";
import { isResolvableAccountApiId } from "helpers/viewContext";

type UseGetAccountByIdOptions = Parameters<typeof useGetAccountQuery>[1];

/**
 * Wraps useGetAccountQuery so reserved role-switcher ids (Accounts, Funders, etc.)
 * never hit GET /api/v2/accounts/:id.
 */
export function useGetAccountByIdQuery(
  accountId: string | undefined | null,
  options?: UseGetAccountByIdOptions,
) {
  const id = accountId ?? "";
  const skipInvalidId = !isResolvableAccountApiId(accountId);

  return useGetAccountQuery(id, {
    ...options,
    skip: Boolean(options?.skip) || skipInvalidId,
  });
}
